import { useNavigate } from "@tanstack/react-router"
import { useCreateTenantMutation } from "./api"
import { useRedirectAfterLogin } from "@/auth"
import { ApiFormWrapper, FormError, FormInput, FormSubmitButton } from "@/form"
import { useT } from "@/i18n"

export default function TenantCreateForm() {
  const { t } = useT("tenant")
  const [createTenant] = useCreateTenantMutation()
  const { getRedirectUrl } = useRedirectAfterLogin()
  const navigate = useNavigate()

  const handleSuccess = () => navigate({ to: getRedirectUrl(), replace: true })

  return (
    <ApiFormWrapper
      defaultValues={{ name: "" }}
      action={createTenant}
      onSuccess={handleSuccess}
    >
      <FormInput name="name" autoFocus required className="mb-3 w-full" />
      <FormError />
      <FormSubmitButton>{t("createWorkspace")}</FormSubmitButton>
    </ApiFormWrapper>
  )
}
